import { InductionIcon } from './InductionIcon';

/**
 * author: Michael Irigoyen
 * id 9B626C0C-73AD-4209-BEB6-70AE9BA4D1FF
 * name induction
 * version: 6.2.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/induction.svg
 * tags
 * - Home Automation 
 * - Automotive 
 */
export const IgnitionIcon = InductionIcon;
export default IgnitionIcon